import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetJobs } from './jobThunk';
import { IJobs } from '~/utils/interface/job';
import { StatusMode } from '~/utils/types/job';

type StatusModeState = StatusMode | 'all';
type SortParams = {
  field: string;
  type: 'ASC' | 'DESC';
};

export interface JobState {
  jobs: Array<IJobs>;
  countsJobPerStatusMode: {
    all: number;
    progress: number;
    hold: number;
    completed: number;
    [key: string]: number;
  };
  sortBy: Array<SortParams>;
  searchInput: string;
  statusMode: StatusModeState;
  totalPages: number;
}

const initialState: JobState = {
  jobs: [],
  countsJobPerStatusMode: {
    all: 0,
    progress: 0,
    hold: 0,
    completed: 0,
  },
  sortBy: [],
  searchInput: '',
  statusMode: 'all',
  totalPages: 0,
};

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    changeStatusMode(state, action: PayloadAction<StatusModeState>) {
      state.statusMode = action.payload;
    },
    changeSearchInput(state, action: PayloadAction<string>) {
      state.searchInput = action.payload;
    },

    // only use single sort, multiple sort will be implement next time
    changeSortBy(state, action: PayloadAction<SortParams>) {
      state.sortBy = [action.payload];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetJobs.pending, (state, action) => {})
      .addCase(handleGetJobs.fulfilled, (state, action) => {
        state.jobs = [...action.payload.responses];
        state.countsJobPerStatusMode = {
          all: action.payload.countAll,
          progress: action.payload.countInProgress,
          hold: action.payload.countHold,
          completed: action.payload.countCompleted,
        };
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(handleGetJobs.rejected, (state, action) => {});
  },
});

export const jobActions = jobSlice.actions;

const jobReducer = jobSlice.reducer;
export default jobReducer;
